export default {
  WEDDING_PAGE_LOGIN_NEW_USER: ['enterUsername', 'enterDisplayName', 'enterWeddingCode', 'enterPassword'],
  WEDDING_PAGE_LOGIN_NEW_GUEST_FOR_WEDDING: ['enterUsername', 'enterWeddingCode', 'enterPassword'],
  WEDDING_PAGE_LOGIN_EXISTING_GUEST: ['enterUsername', 'enterPassword'],
  GENERAL_LOGIN_NEW_USER: ['enterUsername', 'enterDisplayName', 'enterPassword'],
  GENERAL_LOGIN_EXISTING_USER: ['enterUsername', 'enterPassword'],
};
